import React, { useEffect, useState } from "react";
import {
  GridColumnMenuSort,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
} from "@progress/kendo-react-grid";
import { get, isEmpty, orderBy } from "lodash";
import { CompanyDetails } from "../../recoil/LoggedInUserDetail/selector";
import { useRecoilValue } from "recoil";

export const CustomColumnMenu = (props) => {
  let companyDetail = useRecoilValue(CompanyDetails);
  const [columnsExpanded, setColumnsExpanded] = useState(false);
  const [filterExpanded, setFilterExpanded] = useState(false);

  const { column } = props;

  const onFilterExpandChange = (value) => {
    setFilterExpanded(value);
    setColumnsExpanded(value ? false : columnsExpanded);
  };

  const sortFilterData = () => {
    return orderBy(get(props, "data", []), `${get(column, "field")}`);
  };

  const getStatusAsPerFilter = (key) => {
    switch (key) {
      case "assigned":
        return ["Active", "Paused", "Pending", "Planned", "Overdue"];
      case "active":
        return ["Active"];
      case "pending":
        return ["Pending"];
      case "deactivated":
        return ["Deactivated"];
      case "reactivated":
        return ["Reactivated"];
      case "submitted":
        return ["Closed", "Incomplete"];
      case "archived":
        return ["Archived"];
      case "team":
        return ["Active", "Hold", "Pending", "Planned", "Overdue"];
      case "all":
        return [
          "Active",
          "Closed",
          "Incomplete",
          "Paused",
          "Pending",
          "Planned",
          "Overdue",
          "Draft",
        ];
      case "coaching":
        return ["Active", "Paused", "Planned", "Overdue", "Draft"];
      default:
        break;
    }
  };

  const getFilter = () => {
    if (get(column, "filter") === "date") {
      return (
        <GridColumnMenuFilter
          {...props}
          onExpandChange={onFilterExpandChange}
          expanded={filterExpanded}
        />
      );
    }
    if (get(column, "filter") !== "date") {
      const updatedProps = { ...props };
      if (props?.variables) {
        const variableFilters = {
          ...JSON.parse(get(props, "variables.listFilter.dataState", {})),
        };
        if (variableFilters?.filters) {
          variableFilters.filters = {
            filters: variableFilters?.filters,
            logic: "and",
          };
          updatedProps.filter = variableFilters?.filters;
        }
      }
      switch (get(column, "field")) {
        case "title":
        case "name":
        case "fullName":
        case "coaches":
        case "creator":
        case "employee":
        case "collaborator":
        case "users":
        case "description":
        case "people":
          return (
            <GridColumnMenuFilter
              {...updatedProps}
              hideSecondFilter={true}
              onExpandChange={onFilterExpandChange}
              expanded={filterExpanded}
            />
          );
        case "type": {
          return (
            <GridColumnMenuCheckboxFilter
              {...updatedProps}
              data={
                (get(companyDetail, "referenceFeature.target", []) || []).length
                  ? get(companyDetail, "referenceFeature.target", []).map(
                      (t) => ({
                        type: t.name,
                      })
                    )
                  : []
              }
              onExpandChange={onFilterExpandChange}
              expanded={filterExpanded}
              searchBoxFilterOperator={"contains"}
            />
          );
        }
        case "userTargetStatus":
        case "typeIndividualTeam":
        case "statusSuccessStory":
        case "status": {
          return (
            <GridColumnMenuCheckboxFilter
              {...updatedProps}
              data={
                props?.selectedFilter && !isEmpty(props?.selectedFilter)
                  ? getStatusAsPerFilter(
                      get(props, "selectedFilter.filterKey", "assigned")
                    ).map((s) => ({ status: s }))
                  : sortFilterData()
              }
              onExpandChange={onFilterExpandChange}
              expanded={filterExpanded}
              searchBoxFilterOperator={"contains"}
            />
          );
        }
        case "userGroupDepartmentList": {
          /*  console.log(get(props, "data", []));
          let userGroups = get(props, "data", []).map(ug => ug[`${get(column, "field")}`] && Array.isArray(ug[`${get(column, "field")}`]) ? ug[`${get(column, "field")}`] : []);
          userGroups = userGroups.flat()
          console.log(get(column, "field"), 'userGroups', userGroups.map(
            ug => ({
              [`${get(column, "field")}`]: ug
            })
          ));
          return (
            <GridColumnMenuCheckboxFilter
              {...updatedProps}
              data={userGroups.map(
                ug => ({
                  userGroup: ug
                })
              )}
              onExpandChange={onFilterExpandChange}
              expanded={filterExpanded}
              searchBoxFilterOperator={"contains"}
            />
          ); */
          return (
            <GridColumnMenuFilter
              {...updatedProps}
              hideSecondFilter={true}
              onExpandChange={onFilterExpandChange}
              expanded={filterExpanded}
            />
          );
        }
        default:
          break;
      }
      return (
        <GridColumnMenuCheckboxFilter
          {...updatedProps}
          data={sortFilterData()}
          onExpandChange={onFilterExpandChange}
          expanded={filterExpanded}
          searchBoxFilterOperator={"contains"}
        />
      );
    }
  };
  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      {props.sortable && <GridColumnMenuSort {...props} />}
      {getFilter()}
    </div>
  );
};
export default CustomColumnMenu;
